import GetPrivateData from '../Classes/GetPrivateData.js';

export default /*window['fetch'] ||*/ function fetch(uri,data)
{
	data = data || {};
	return new Promise
	(
		(res, rej) =>
		{
			const xhr = new XMLHttpRequest();
			xhr.open(data.method || 'GET', uri);
			xhr.onreadystatechange = function()
			{
				if (xhr.readyState !== 4)
				{
					return;
				}
				xhr.onreadystatechange = null;
				if (xhr.status !== 0 && xhr.status < 400)
				{
					const result = new FetchResponse(xhr.responseText);
					res(result);
				}
				else
				{
					rej(`Error ${xhr.status}: ${xhr.statusText}`);
				}
			};
			xhr.send(data.body);
		}
	);
}

class FetchResponse
{
	constructor(responseText)
	{
		getPrivateResponseData.for(this).responseText = responseText;
	}

	text()
	{
		return new Promise
		(
			res =>
			{
				const privateData = getPrivateResponseData.for(this);
				if(!privateData.hasOwnProperty('responseText'))
				{
					throw Error('ResponseBody is Locked');
				}
				const data = privateData.responseText;
				delete privateData.responseText;
				res(data);
			}
		);
	}

	json()
	{
		return this.text().then( text => JSON.parse(text) );
	}
}

const getPrivateResponseData = new GetPrivateData(FetchResponse);